export default {
  Code: 'Code',
  Employee: 'employee',
  employee: 'Employee',
  Outlet: 'outlet',
  outlet: 'Outlet',
  good: 'Good',
  Tax: 'tax',
  'm-orm-delete-dialog': {
    't-part-1': 'Are you really want delete',
    't-part-2': 'from dictionary?',
    title: '@:m-orm-delete-dialog.t-part-1 {type} "{name}" @:m-orm-delete-dialog.t-part-2',
    'n-part-1': 'You have deleted',
    notification: '@:m-orm-delete-dialog.n-part-1 {type} "{name}"!'
  },
  'm-orm-activate-dialog': {
    't-part-1': 'Are you really want to activate',
    title: '@:m-orm-activate-dialog.t-part-1 {type} "{name}"',
    'n-part-1': 'You have activated',
    notification: '@:m-orm-activate-dialog.n-part-1 {type} "{name}"!'
  },
  'm-orm-deactivate-dialog': {
    't-part-1': 'Are you really want to deactivate',
    title: '@:m-orm-deactivate-dialog.t-part-1 {type} "{name}"',
    'n-part-1': 'You have deactivated',
    notification: 'm-orm-deactivate-dialog.n-part-1 {type} "{name}"!'
  },
  'm-orm-reset-pincode-dialog': {
    title: 'Are you really want to reset pincode ?'
  },
  'm-orm-copy-dialog': {
    't-part-1': 'Are you really want to create copy of',
    title: '@:m-orm-copy-dialog.t-part-1 {type} "{name}" ?',
    'n-part-1': 'Copy for ',
    'n-part-2': 'was created successfully!',
    notification: '@:m-orm-copy-dialog.n-part-1 {type} "{name}" @:m-orm-copy-dialog.n-part-2'
  },
  'm-orm-toggle-status-dialog': {
    't-deactivation-part-1': 'Are you sure you want to deactivate',
    't-activations-part-1': 'Are you sure you want to activate',
    't-part-3': 'with all nested',
    title: {
      deactivation: '@:m-orm-toggle-status-dialog.t-deactivation-part-1 {type} "{name}" @:m-orm-toggle-status-dialog.t-part-3 {children}?',
      activation: '@:m-orm-toggle-status-dialog.t-activations-part-1 {type} "{name}" @:m-orm-toggle-status-dialog.t-part-3 {children}?'
    },
    'n-deactivated-part-1': 'You have deactivated',
    'n-activated-part-1': 'You have activated',
    notification: {
      deactivation: '@:m-orm-toggle-status-dialog.n-deactivated-part-1 {type} "{name}"!',
      activation: '@:m-orm-toggle-status-dialog.n-activated-part-1 {type} "{name}"!'
    }
  },
  'm-orm-synchronization-dialog': {
    title: 'Synchronize all workplace data?',
    part1: 'Warning!',
    part2: 'This operation is intended to start the workplace for the first time. Follow only if you are confident in your actions',
    part3: 'If used incorrectly, the operation will cause data to be duplicated in the workplace'
  },
  'm-orm-card-dialog': {
    title: '{type} card "{name}"'
  },
  'm-orm-assign-dialog': {
    't-part-1': 'Appointment',
    't-part-2': 'for',
    'n-part-1': 'Appointed',
    'n-part-2': 'for',
    title: '@:m-orm-assign-dialog.t-part-1 {whom} @:m-orm-assign-dialog.t-part-2 {type} "{name}"',
    notification: '@:m-orm-assign-dialog.n-part-1 {whom} was successfully updated!'
  },
  employeeWarning: {
    part1: 'Importantly! Before you add Employees, make sure you fill out the Access Profiles Directory '
  },
  'Version of application': 'Version of application: {version}',
  'e-input-dynamic': {
    header: 'The maximum number of rows in the check cap {max}',
    footer: 'The maximum number of rows in the check cellar {max}'
  }
}
